import client from './client';

export const vmAttackSurfaceApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/vm/attack-surface', { params });
    return data;
  },

  async forHost(hostId, params = {}) {
    const { data } = await client.get(`/api/vm/hosts/${hostId}/attack-surface`, { params });
    return data;
  },
};
